/* eslint-disable max-len */
import React from "react";

export const DocumentsSVGComponent = ({ isActive }) =>
    isActive ? (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.27278 3.86379H1.50009V3.38653C1.50009 2.06831 2.56822 1.00018 3.88643 1.00018C5.20465 1.00018 6.27278 2.06831 6.27278 3.38653V3.86379Z"
                fill="#A86D37"
                stroke="#A86D37"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0455 19.1364V19.6137C11.0455 21.7614 8.65912 22 8.65912 22H20.1136C21.4318 22 22.4999 20.9319 22.4999 19.6137V19.1364H11.0455Z"
                fill="#A86D37"
                stroke="#A86D37"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.6363 19.1362V3.38634C19.6363 2.06813 18.5682 1 17.25 1H3.88644C5.20466 1 6.27279 2.06813 6.27279 3.38634V19.6135C6.27279 20.9317 7.34091 21.9998 8.65913 21.9998H19.6363"
                fill="#A86D37"
            />
            <path
                d="M19.6363 19.1362V3.38634C19.6363 2.06813 18.5682 1 17.25 1H3.88644C5.20466 1 6.27279 2.06813 6.27279 3.38634V19.6135C6.27279 20.9317 7.34091 21.9998 8.65913 21.9998H19.6363"
                stroke="#A86D37"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0909 5.77289H15.8181"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0909 9.591H15.8181"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0909 13.4092H15.8181"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0454 19.1365V19.6137C11.0454 21.7615 8.65903 22.0001 8.65903 22.0001H20.1135C21.4317 22.0001 22.4998 20.932 22.4998 19.6137V19.1365H11.0454V19.1365Z"
                stroke="#242E35"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.27278 3.86385H1.50009V3.38659C1.50009 2.06837 2.56822 1.00024 3.88643 1.00024V1.00024C5.20465 1.00024 6.27278 2.06837 6.27278 3.38659V3.86385V3.86385Z"
                stroke="#242E35"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.6363 19.1362V3.38634C19.6363 2.06813 18.5682 1 17.25 1H3.88644C5.20466 1 6.27279 2.06813 6.27279 3.38634V19.6135C6.27279 20.9317 7.34091 21.9998 8.65913 21.9998H19.6363"
                stroke="#242E35"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0909 5.77283H15.8181"
                stroke="#242E35"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0909 9.59106H15.8181"
                stroke="#242E35"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.0909 13.4092H15.8181"
                stroke="#242E35"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
